export default __webpack_public_path__ + "static/media/FB3.57efd33f.png";